import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.75 18a.75.75 0 0 1-.75.75H6.75A3.754 3.754 0 0 1 3 15V9a3.754 3.754 0 0 1 3.75-3.75H12a.75.75 0 1 1 0 1.5H6.75C5.51 6.75 4.5 7.76 4.5 9v6c0 1.24 1.01 2.25 2.25 2.25H12a.75.75 0 0 1 .75.75M9 15.75a.75.75 0 0 0 .75-.75V9.75h1.5a.75.75 0 1 0 0-1.5h-4.5a.75.75 0 1 0 0 1.5h1.5V15c0 .415.336.75.75.75m7.5 3.75a.75.75 0 0 1-.75-.75V5.25a.75.75 0 0 1 .75-.75.75.75 0 0 0 0-1.5 2.24 2.24 0 0 0-1.5.575A2.24 2.24 0 0 0 13.5 3a.75.75 0 1 0 0 1.5.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75.75.75 0 0 0 0 1.5 2.24 2.24 0 0 0 1.5-.575 2.24 2.24 0 0 0 1.5.575.75.75 0 1 0 0-1.5m1.688-14.132a.75.75 0 1 0-.375 1.453A2.25 2.25 0 0 1 19.501 9v6a2.25 2.25 0 0 1-1.688 2.179.75.75 0 0 0 .375 1.453A3.75 3.75 0 0 0 21 15V9a3.75 3.75 0 0 0-2.812-3.632"
    }, null, -1)
  ]))]))
}
export default { render: render }